export default "__VITE_ASSET__DqncRr1b__"